import queryClient from '@/utils/queryClient'
import type { Updater } from '@tanstack/query-core'
import { useQuery } from '@tanstack/react-query'
import type { PostFormValue } from './types'

export const IS_POST_FORM_MODAL_SHOW_QUERY_OPTIONS_KEY = ['IS_POST_FORM_MODAL_SHOW']
export function setIsPostFormModalShow(updater: Updater<boolean, boolean>) {
	return queryClient.setQueryData<boolean>(
		IS_POST_FORM_MODAL_SHOW_QUERY_OPTIONS_KEY,
		updater as Updater<boolean | undefined, boolean | undefined>
	)
}
export function useIsPostFormModalShow() {
	const { data } = useQuery<boolean>({
		queryKey: IS_POST_FORM_MODAL_SHOW_QUERY_OPTIONS_KEY,
		initialData: false,
	})
	return [data, setIsPostFormModalShow] as const
}

export const POST_DEFAULT_FORM_VALUE_QUERY_OPTIONS_KEY = ['POST_DEFAULT_FORM_VALUE']
export function setPostDefaultFormValue(updater: Updater<PostFormValue, PostFormValue>) {
	return queryClient.setQueryData<PostFormValue>(
		POST_DEFAULT_FORM_VALUE_QUERY_OPTIONS_KEY,
		updater as Updater<PostFormValue | undefined, PostFormValue | undefined>
	)
}
export function resetPostDefaultFormValue() {
	return queryClient.resetQueries({ queryKey: POST_DEFAULT_FORM_VALUE_QUERY_OPTIONS_KEY })
}
export function usePostDefaultFormValue() {
	const { data } = useQuery<PostFormValue>({
		queryKey: POST_DEFAULT_FORM_VALUE_QUERY_OPTIONS_KEY,
		initialData: undefined,
	})
	return [data, setPostDefaultFormValue] as const
}
